import { React, useState, useEffect } from "react";
import styled from "styled-components";
import { Layout, Table, Button, PageHeader } from "antd";
import {
  RightLayoutContainer,
  OtherPages,
  PageTitleComp,
} from "../styledElements";
import logoCompany from "../../Assets/Images/logo.svg";
import Iconmoon from "../../Components/IconsFiles/icon";
import * as htmlToImage from "html-to-image";
//import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
//import { jsPDF } from "jspdf";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { paperMachineListData } from "../../Services/machineServices";
import { useLocation, useNavigate } from "react-router";
import moment from "moment";
import { getCompanyDetails } from "../../Services/companyServices";

const PrintData = styled.div`
  padding: 0px;
  margin: 40px auto;
  background-color: #fff;
  width: 845px;
`;
const ExportHeader = styled.div`
  background-color: #faf9f8;
  padding: 10px 15px;
  .file-header {
    display: flex;
    justify-content: space-between;
  }
  .file-header-logo {
    width: 130px;
    display: flex;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .client-name {
    width: 25%;
  }
  .client-name h4 {
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    margin: 0px;
  }
  .client-name h6 {
    font-style: italic;
    color: #605e5c;
    font-size: 10px;
    margin: 0px;
  }
  .client-data {
    display: flex;
    > div {
      width: 50%;
      label {
        color: #000;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
      span {
        color: #605e5c;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
    }
  }
`;
const ExportTable = styled.div`
  table {
    width: 100%;
  }
  thead th {
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
  }
  td {
    border-bottom: 1px solid #000;
  }

  th,
  td {
    text-align: left;
    padding: 5px 5px;
  }
  th {
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1.2;
    font-weight: 700;
    font-family: var(--sf-pro-text);
  }
  p {
    margin: 0;
    font-family: var(--sf-pro-text);
  }
  .order-d {
    p {
      text-transform: uppercase;
      font-size: 7px;
      font-weight: 600;
    }
    .order-d-l {
      p {
        text-transform: none;
        color: #605e5c;
        font-size: 7px;
        font-weight: 400;
      }
    }
  }
  .date {
    color: #000;
    font-size: 8px;
    font-weight: 600;
  }
  .p-detail {
    font-size: 7px;
    font-weight: 600;
    color: #605e5c;
  }
  .factor {
    color: #000;
    font-size: 7px;
    font-weight: 600;
    font-style: italic;
  }
  .p-ton {
    font-size: 8px;
    font-weight: 600;
    color: #000;
  }
  .reel {
    font-size: 8px;
    color: #605e5c;
    font-style: italic;
  }
  .remark {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 90px;
    line-height: 1.2;
  }
  .address {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 170px;
    line-height: 1.2;
  }
  .ms-2 {
    width: 50px;
  }
  .f-10 {
    font-size: 10px !important;
  }
  .sub-text {
    font-size: 10px;
    color: #605e5c;
  }
  .disabled{
    background: #F3F2F1;
  }
`;

function addScript(url) {
  const script = document.createElement("script");
  script.type = "application/javascript";
  script.src = url;
  document.head.appendChild(script);
}
addScript(
  "https://raw.githack.com/eKoopmans/html2pdf/master/dist/html2pdf.bundle.js"
);

const ExportCustomerPdf = (props) => {
  const [showLoader, setLoader] = useState(false);
  const [company, setCompany] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const [customerRecords, setCustomerRecords] = useState(
    location.state.customerRecords
  );
  const [businessDetail, setBusinessDetail] = useState(
    location.state.businessDetail
  );
  const [deliveryDetail, setDeliveryDetail] = useState(
    location.state.deliveryDetail
  );
  const [fileNameForPDF, setFileNameForPDF] = useState(location.state?.fileNameForPDF);
  // const timeElapsed = Date.now();
  // const today = new Date(timeElapsed);
  const currentDate = new Date();
  const today = (currentDate.getDate() + " " + currentDate.toLocaleString("default", { month: "long" }) + "," +  currentDate.getFullYear());
  //   console.log(customerRecords);

  useEffect(() => {
    setCompanyDetails();
  }, []);

  const setCompanyDetails = () => {
    getCompanyDetails()
      .then((response) => {
        setCompany(response.data);
      })
      .catch((error) => console.log("Error", error));
  };

  const exportHandler = () => {
    const input = document.getElementById("export-content");
    html2canvas(input, { useCORS: true, allowTaint: true, scrollY: 0 }).then(
      (canvas) => {
        const image = { type: "jpeg", quality: 0.98 };
        const margin = [0.5, 0.5];
        const filename = "myfile.pdf";

        var imgWidth = 8.5;
        var pageHeight = 11;

        var innerPageWidth = imgWidth - margin[0] * 2;
        var innerPageHeight = pageHeight - margin[1] * 2;

        // Calculate the number of pages.
        var pxFullHeight = canvas.height;
        var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
        var nPages = Math.ceil(pxFullHeight / pxPageHeight);

        // Define pageHeight separately so it can be trimmed on the final page.
        var pageHeight = innerPageHeight;

        // Create a one-page canvas to split up the full image.
        var pageCanvas = document.createElement("canvas");
        var pageCtx = pageCanvas.getContext("2d");
        pageCanvas.width = canvas.width;
        pageCanvas.height = pxPageHeight;

        // Initialize the PDF.
        var pdf = new jsPDF("p", "in", [8.5, 11]);

        for (var page = 0; page < nPages; page++) {
          // Trim the final page to reduce file size.
          if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
            pageCanvas.height = pxFullHeight % pxPageHeight;
            pageHeight =
              (pageCanvas.height * innerPageWidth) / pageCanvas.width;
          }

          // Display the page.
          var w = pageCanvas.width;
          var h = pageCanvas.height;
          pageCtx.fillStyle = "white";
          pageCtx.fillRect(0, 0, w, h);
          pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

          // Add the page to the PDF.
          if (page > 0) pdf.addPage();
          // debugger;
          var imgData = pageCanvas.toDataURL(
            "image/" + image.type,
            image.quality
          );
          pdf.addImage(
            imgData,
            image.type,
            margin[1],
            margin[0],
            innerPageWidth,
            pageHeight
          );
        }

        pdf.save(fileNameForPDF+".pdf");
      }
    );
  };

  return (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() =>
            navigate("../customer-records/export-customer", {
              state: {
                body: location?.state?.body,
                rootPage: location?.state?.rootPage,
                fileName: fileNameForPDF,
                customerRecords: customerRecords,
                businessDetail: businessDetail,
                deliveryDetail: deliveryDetail,
                onBack: true,
              },
            })
          }
          title="Customer Records Preview"
          extra={[
            <Button
              key="1"
              className="themeBtn"
              onClick={() => exportHandler()}
            >
              <Iconmoon icon="download" size={17} color="#FFFFFF" />
              Download Customer Records
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      {/* <Button onClick={() => exportHandler()} className="themeBtn">
        Download Customer Records
      </Button> */}
      <PrintData id="export-content">
        <OtherPages>
          <Layout
            style={{
              backgroundColor: "#ffffff",
            }}
          >
            <div>
              <ExportHeader>
                <div className="file-header">
                  <div className="file-header-logo">
                    <img src={logoCompany} alt="Kaiznn" />
                  </div>
                  <div className="client-name">
                    {company && <h4>{company.business_name}</h4>}
                    <h6>Customer Records</h6>
                    <div className="client-data">
                      <div>
                        <label>Number of records</label>
                        <span>{customerRecords.length}</span>
                      </div>
                      <div>
                        <label>Date:</label>
                        <span>{today}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </ExportHeader>
              <ExportTable>
                <table>
                  <thead>
                    <tr>
                      <th>CUSTOMER CODE</th>
                      <th>CUSTOMER DETAILS</th>
                      <th>CONTACT DETAILS</th>
                      {businessDetail && <th>BUSINESS DETAILS</th>}
                      {deliveryDetail && <th>DELIVERY ADDRESS</th>}
                      <th>CUSTOMER TYPE</th>
                      <th>CATEGORY OF CUSTOMER</th>
                      <th>REMARKS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customerRecords.map((customer) => {
                      return (
                        <tr
                          className={
                            customer.status === "Disabled" ? "disabled" : ""
                          }
                        >
                          <td>
                            <div className="main-text">
                              <p className="p-ton f-10">{customer.code||"-"}</p>

                              <div className="status">
                                <p className="reel f-10">{customer.status||"-"}</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <p className="p-ton f-10">{customer.name||"-"}</p>
                            <p className="address sub-text">
                              {customer.address||"-"}
                            </p>
                          </td>
                          <td>
                            <p className="p-ton f-10">
                              {customer.contact.person||"-"}
                            </p>
                            <p className="sub-text">
                              {customer.contact.number||"-"}
                            </p>
                            <p className="sub-text">{customer.contact.email||"-"}</p>
                          </td>
                          {businessDetail && (
                            <td>
                              <p className="p-ton f-10">
                                {customer.businessDetails.pan
                                  ? `PAN: ${customer.businessDetails.pan}`
                                  : null}
                              </p>
                              <p className="p-ton f-10">
                                {customer.businessDetails.gst
                                  ? `GSt: ${customer.businessDetails.gst}`
                                  : null}
                              </p>
                              <p className="p-ton f-10">
                                {customer.businessDetails.dealershipDate
                                  ? `DD: ${customer.businessDetails.dealershipDate}`
                                  : null}
                              </p>
                            </td>
                          )}
                          {deliveryDetail && (
                            <td>
                              <p className="address f-10">
                                {customer.deliveryAddress||"-"}
                              </p>
                            </td>
                          )}
                          <td>
                            <p className="p-ton f-10">{customer.type||"-"}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{customer.category||"-"}</p>
                          </td>
                          <td>
                            <p className="remark f-10">{customer.remarks||"-"}</p>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </ExportTable>
            </div>
          </Layout>
        </OtherPages>
      </PrintData>
    </RightLayoutContainer>
  );
};
export default ExportCustomerPdf;
